/*******************ROUTES*********************/
export const ROLE_USER = {
  profile: '/profile',
  security: '/security',
  logout: '/logout',
  dashboard: '/dashboard',
  listDocuments: '/documents',
  mediaManager: '/media-manager'
}

export const ROLE_MAIRIE = {
  districts: '/districts',
  missionContacts: '/mission-contacts',
  sterilizations: '/sterilizations',
  sterilizationShow: '/sterilizations/:id',
  pages: '/pages',
  mailTemplates: '/mail-templates',
  missionPilots: '/pilots',
  missionBilling: '/billing',
  paymentModes: '/payment-modes',
  editPaymentMode: '/edit-payment-mode',
  freeCodes: '/free-codes',
  nuisances: '/nuisances'
}

export const ROLE_PILOT = {
  sterilizations: '/sterilizations',
  missionPreparation: '/prepare-mission',
  missionAuthorization: '/mission-autorization',
  scanJourney: '/scan-journey',
  sterilizationShow: '/sterilizations/:id'
}

export const ROLE_ADMIN = {
  missions: '/missions',
  missionSeasons: '/mission-seasons',
  users: '/users',
  createMission: '/create-mission',
  createUser: '/create-user',
  updateUser: '/update-user',
  userInfos: '/user-infos',
  ...ROLE_MAIRIE
}

export const ROLE_SUPER_ADMIN = {
  ...ROLE_ADMIN,
  managePermissions: '/permissions',
  manageAuthorizations: '/authorizations/:id',
  missionSubjects: '/mission-subjects',
  ...ROLE_MAIRIE
}

export const ROLE_PUBLIC = {
  home: '/',
  pageShow: '/:slug',
  login: '/login',
  paymentPage: '/payment',
  postPaymentPage: '/payment/:orderReference',
  privacyPage: '/politique-de-confidentialite',
  citizenSterilizationCall: '/citizen-sterilization-call',
  companySterilizationCall: '/company-sterilization-call',
  publicValidation: '/confirmation-ok',
  emailValidation: '/email-validation/:validationToken'
}

export const routesList = {
  ...ROLE_PUBLIC,
  ...ROLE_USER,
  ...ROLE_ADMIN,
  ...ROLE_SUPER_ADMIN,
  ...ROLE_PILOT,
  ...ROLE_MAIRIE
}

/*******************MENUS*********************/
const ROLE_USER_MENU = {
  dashboard: ROLE_USER.dashboard,
  profile: {
    myProfile: ROLE_USER.profile,
    security: ROLE_USER.security,
  },
  mediaManager: ROLE_USER.mediaManager
}
const ROLE_MAIRIE_MENU = {
  ...ROLE_USER_MENU,
  utils: {
    mailTemplates: ROLE_MAIRIE.mailTemplates,
    pages: ROLE_MAIRIE.pages,
  },
  mission: {
    districts: ROLE_MAIRIE.districts,
    missionContacts: ROLE_MAIRIE.missionContacts,
    listDocuments: ROLE_USER.listDocuments,
    missionPilots: ROLE_MAIRIE.missionPilots,
    nuisances: ROLE_MAIRIE.nuisances

  },
  payment: {
    paymentModes: ROLE_MAIRIE.paymentModes,
    freeCodes: ROLE_MAIRIE.freeCodes,
    missionBilling: ROLE_MAIRIE.missionBilling
  },
  listSterilizationCalls: ROLE_MAIRIE.sterilizations,
}

const ROLE_PILOT_MENU = {
  ...ROLE_USER_MENU,
  listSterilizationCalls: ROLE_PILOT.sterilizations,
  currentMission: {
    listDocuments: ROLE_USER.listDocuments,
    missionPreparation: ROLE_PILOT.missionPreparation,
    scanJourney: ROLE_PILOT.scanJourney
  }
}

const ROLE_ADMIN_MENU = {
  ...ROLE_USER_MENU,
  manageUsers: ROLE_ADMIN.users,
  manageMissionSeasons: ROLE_ADMIN.missionSeasons,
  listSterilizationCalls: ROLE_SUPER_ADMIN.sterilizationCalls,
  ...ROLE_MAIRIE_MENU,
  utils: {
    mailTemplates: ROLE_MAIRIE.mailTemplates,
    pages: ROLE_MAIRIE.pages,
  }
}


const ROLE_SUPER_ADMIN_MENU = {
  ...ROLE_ADMIN_MENU
}

const ROLE_ADMIN_PANEL_MENU = {
  ...ROLE_USER_MENU,
  manageMissions: ROLE_SUPER_ADMIN.missions,
  manageUsers: ROLE_SUPER_ADMIN.users,
  managePermissions: ROLE_SUPER_ADMIN.managePermissions,
  payment: {
    paymentModes: ROLE_MAIRIE.paymentModes,
    freeCodes: ROLE_MAIRIE.freeCodes,
    missionBilling: ROLE_MAIRIE.missionBilling
  },
  utils: {
    mailTemplates: ROLE_MAIRIE.mailTemplates,
    pages: ROLE_MAIRIE.pages,
    missionSubjects: ROLE_SUPER_ADMIN.missionSubjects,
    manageMissionSeasons: ROLE_SUPER_ADMIN.missionSeasons
  }
}

export const ROLES_MENU = {
  ROLE_MAIRIE_MENU,
  ROLE_PILOT_MENU,
  ROLE_ADMIN_MENU,
  ROLE_SUPER_ADMIN_MENU,
  ROLE_ADMIN_PANEL_MENU
}

